<template>
  <div class="form-group" :class="classFormGroup">
    <label v-if="label" class="w-100" :style="labelStyle">{{ label }}
      <span v-if="required" style="color: red;"> *</span>
      <br>
      <span v-if="validation?.$error" style="color: red;">{{ messages }}</span>
      <span v-if="validationMessage" style="color: red;">{{ validationMessage }}</span>
    </label>

    <div v-if="isCurrency"
        class="d-flex form-control p-0 overflow-hidden"
        :class="{ 'is-invalid': validation?.$error }">

      <div class="font-weight-bold rounded-0 w-100 h-100 form-control border-top-0 border-bottom-0 border-left-0"
           style="background-color: #e9ecef; max-width: 35px;">€
      </div>
      <input
          type="text"
          :value="modelValue"
          @input="handleInput"
          :style="inputStyle"
          :min="min"
          :max="max"
          :step="decimalPlaces ? (1 / Math.pow(10, decimalPlaces)) : 'any'"
          :placeholder="placeholder"
          :disabled="disabled"
          class="h-100 border-0 pl-2 form-control text-right">
    </div>
    <input v-if="!isCurrency"
           type="text"
           :value="modelValue"
           @input="handleInput"
           :style="inputStyle"
           :min="min"
           :max="max"
           :step="decimalPlaces ? (1 / Math.pow(10, decimalPlaces)) : 'any'"
           :placeholder="placeholder"
           class="form-control text-right"
           :disabled="disabled"
           :class="{ 'is-invalid': validation?.$error }">
  </div>
</template>

<script setup>
  import { defineEmits, defineProps, toRefs } from 'vue';

  const props = defineProps({
    modelValue: {
      type: [String, Number, null],
      required: true,
    },
    label: {
      type: [String, Boolean],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: [String, Boolean],
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    classFormGroup: {
      type: String,
      default: '',
    },
    isCurrency: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      default: () => ({}),
    },
    messages: {
      type: [Object, String, Array],
      default: () => ({}),
    },
    validationMessage: {
      type: [String, null],
      default: '',
    },
    decimalPlaces: {
      type: Number,
      default: 0, 
    },
    inputStyle: {
      type: Object,
    },
    labelStyle: {
      type: Object,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 1000000,
    },
  });

  const emit = defineEmits(['update:modelValue']);
  const { modelValue, max, decimalPlaces} = toRefs(props);

  const handleInput = (event) => {
    let inputValue = event.target.value;

    inputValue = decimalPlaces.value
      ? inputValue.replace(/(?!^-)[^0-9.]/g, '')
      : inputValue.replace(/(?!^-)[^0-9]/g, '');

    // Ukloni minus ako nije na početku
    if (inputValue.includes('-') && inputValue.indexOf('-') > 0) {
      inputValue = inputValue.replace(/-/g, '');
    }

    if (inputValue.split('.').length > 2) {
      inputValue = inputValue.slice(0, inputValue.lastIndexOf('.'));
    }

    if (props.decimalPlaces > 0) {
      const decimalIndex = inputValue.indexOf('.');
      if (decimalIndex !== -1) {
        inputValue = inputValue.slice(0, decimalIndex + props.decimalPlaces + 1);
      }
    }

    let numericValue = parseFloat(inputValue);
    let condition = true;

    if (isNaN(numericValue)) {
      numericValue = 0;
    } else if (numericValue > max.value) {
      numericValue = max.value;
      condition = false;
    } else if (numericValue < props.min) {
      numericValue = props.min;
      condition = false;
    }

    emit('update:modelValue', numericValue);
    event.target.value = condition ? inputValue : numericValue;
  };

</script>

<style scoped>
</style>
